export const NEWS_ARTICLE_SECTION_TEST_ID = "news-article-section";
export const NEWS_DISCLAIMER_TEXT_TEST_ID = "news-disclaimer-text";
export const NEWS_TOP_SECTION_TEST_ID = "news-top-section";
